module.exports = __webpack_public_path__ + "img/9690ba1.jpg";